import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { getDataStatus } from './apiController';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { showToaster, toasterTypes } from '../../widgets';

const QuickDashboard = (props) => {
    const navigate = useNavigate();
    const locationState = useLocation();
    const [projectData, setProjectData] = useState<any>({});
    const [dashboardData, setDashboardData] = useState<any>({});

    useEffect(() => {
        let temp: any = locationState.state;
        console.log(temp)
        setProjectData(temp)
        fetchInitialData();
    }, [])

    /**
         * fetch initial data
         */
    const fetchInitialData = async () => {
        try {
            let temp: any = locationState.state;
            let response = await getDataStatus(temp.TopicID);
            console.log(response)
            const formOrders = response?.data[0]?.all_responses;
            const dashboardDataResp = response?.quick_dashboard;
            const orderedDashboardData = orderDashboardData(dashboardDataResp, formOrders);
            setDashboardData(orderedDashboardData || {});
        } catch (error) {
            showToaster(toasterTypes.ERROR, error?.message || 'Something went wrong');
            console.error(error);
        }
    };

    /**
 * Order dashboard data based on form order
 */
    const orderDashboardData = (dashboardData: any, formOrders: any[]) => {
        if (!dashboardData || !formOrders || !Array.isArray(formOrders)) {
            return dashboardData;
        }

        const orderedData: any = {};

        // First, add items in the order specified by formOrders
        formOrders.forEach((formOrder) => {
            const formName = formOrder.form_name;
            if (dashboardData.hasOwnProperty(formName)) {
                orderedData[formName] = dashboardData[formName];
            }
        });

        // Then, add any remaining items that weren't in formOrders
        Object.keys(dashboardData).forEach((key) => {
            if (!orderedData.hasOwnProperty(key)) {
                orderedData[key] = dashboardData[key];
            }
        });

        return orderedData;
    };

    return (
        <div className="quick-dashboard">
            <div className='pt-2 actions-header'>
                <div className='actions-text'>
                    {
                        window.innerWidth > 700 ?
                            <ArrowLeftOutlined style={{ color: "#fff", fontSize: "28px", margin: "0px 10px" }} onClick={() => navigate(window.innerWidth > 700 ? '/project' : '/projectmobile')} />
                            : ""
                    }
                    {projectData && projectData?.TopicDesc || projectData?.topicdesc}
                </div>
            </div>

            <div className="dashboard-content">
                <div className="dashboard-header">
                    <h2 className="dashboard-title">Quick Dashboard</h2>
                </div>
                {Object.keys(dashboardData).length > 0 ? (
                    <div className="cards-container">
                        {Object.entries(dashboardData).map(([formName, count], index) => (
                            <div key={index} className="dashboard-card">
                                <div className="card-content">
                                    <div className="card-header">
                                        <h3 className="form-name">{formName.replace(/_/g, ' ')}</h3>
                                    </div>
                                    <div className="card-body">
                                        <span className="count-number">{String(count || 0)}</span>
                                        <span className="count-label">Records</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-data">
                        <p>No data available</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default QuickDashboard